import { useSecretCode } from '../components/hooks/useSecretCode';
import { lazy, useRef, useState } from 'react';
import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';
import styles from './Secret.module.less';
import uuid from 'uuid';

const ConfettiExplosion = lazy(() => import('react-confetti-explosion'));
const confettiDuration = 2000;

const Secret = () => {
    const modalRef = useRef(null);
    const confettiRef = useRef(null);
    const [confettiIds, setConfettiIds] = useState([]);

    useSecretCode({
        onComplete: () => {
            if (window) {
                modalRef?.current?.open();
                window.addEventListener('click', (e) => {
                    if (confettiRef?.current) {
                        confettiRef.current.style.left = `${e.pageX}px`;
                        confettiRef.current.style.top = `${e.pageY}px`;
                        const id = uuid.v4();
                        setTimeout(() => {
                            setConfettiIds((prevState) => {
                                return [...prevState.filter((stateId) => stateId !== id)];
                            });
                        }, confettiDuration);
                        setConfettiIds((prevState) => [...prevState, id]);
                    }
                });
            }
        },
    });

    return (
        <>
            <Modal ref={modalRef} ariaLabelledby={'modal-title'}>
                <ModalBlock>
                    <Heading2 id={'modal-title'} aria-label="Du har skrudd på confettimodus">
                        Du har skrudd på:
                    </Heading2>
                    🎉 CONFETTI-MODUS!!! 🎉
                </ModalBlock>
            </Modal>
            <div className={styles.confettiContainer} ref={confettiRef}>
                {confettiIds.map((confettiId) => (
                    <ConfettiExplosion
                        key={confettiId}
                        duration={confettiDuration}
                        particleCount={60}
                        className={styles.confetti}
                    />
                ))}
            </div>
        </>
    );
};

export default Secret;
